import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import { CurrencyRead } from '../../models/currency';
import { JobSearchFilter } from '../../models/job';

export const globalEvents = eventGroup({
  source: 'Global',
  events: {
    clear: type<void>(),
    setStartDate: type<Date>(),
    setEndDate: type<Date>(),
    setPageSize: type<number>(),
    setPage: type<number>(),
    clearSearchFilter: type<void>(),
    saveSearchFilter: type<JobSearchFilter | null>(),
    setLoading: type<boolean>(),
    loadCurrencies: type<{ pageSize: number; page: number }>(),
    loadedCurrencies: type<CurrencyRead[]>(),
  },
});
